var version = {
    "name":      "dativery",
    "buildDateCode": "20251121-144321",
    "buildDate": "Fri Nov 21 2025 14:43:21 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251121-144321",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;